export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_20-f814a15868593e57d951c51b1a443d31.jpg";